<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Evaluations</h6>
                <div><a class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalAssessment" v-bind:disabled="addAssessmentProcess  || deleteAssessmentProcess || activateAssessmentProcess"><i class="fas fa-plus fa-md"></i></a>
                </div>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableAssessment" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Mission</th>
                        <th>Nom</th>
                        <th>Type</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th>Mission</th>
                        <th>Nom</th>
                        <th>Type</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in assessments" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td>{{item.mission_id}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.type}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalAssessment" v-on:click="viewAssessment(item.id)" v-bind:disabled="addAssessmentProcess  || deleteAssessmentProcess || activateAssessmentProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalAssessment" v-on:click="viewAssessment(item.id)" v-bind:disabled="addAssessmentProcess  || deleteAssessmentProcess || activateAssessmentProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Assessment -->
    <div class="modal fade" id="addModalAssessment" tabindex="-1" role="dialog" aria-labelledby="ModalAssessmentLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addAssessmentForm" class="user" action="javascript:void(0);">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalAssessmentLabel">Ajouter Evaluation</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-row">
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
                <div class="col-sm-6">
                  <label>Période</label>
                  <input type="text" class="form-control mb-2" v-model="date1" name="date1" required>
                </div>
                <div class="col-sm-12">
                  <label>Type</label>
                  <select class="custom-select mb-2" v-model="type1"  name="type1" required>
                    <option value="Evaluation Interne">Evaluation Interne</option>
                    <option value="Audit Interne">Audit Interne</option>
                    <option value="Audit Externe">Audit Externe</option>
                  </select>  
                </div>
                <div class="col-sm-12">
                  <label>Déscription</label>
                  <textarea type="text" class="form-control mb-2" v-model="description1" name="description1" required></textarea>
                </div>
                <div class="col-sm-6">
                  <label>Client</label>
                  <select class="custom-select mb-2" v-model="client1" name="client1" required>
                    <option v-for="(item, index) in clients" v-bind:key="item.id" v-bind:value="item.id">{{item.full_name}}</option>
                  </select>  
                  </div>
                <div class="col-sm-6">
                  <label>Mission</label>
                  <select class="custom-select mb-2" v-model="mission1"  name="mission1">
                    <option value="null">Aucune</option>
                    <option v-for="(item, index) in missions" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>  
                </div>
                <div class="col-sm-6">
                  <label>Site</label>
                  <select class="custom-select mb-2" v-model="site1"  name="site1" required>
                    <option v-for="(item, index) in sites" v-bind:key="item.id" v-bind:value="item.id">{{item.name}}</option>
                  </select>  
                </div>
                <div class="col-sm-6">
                  <label>Evaluateur</label>
                  <select class="custom-select mb-2" v-model="assessor1"  name="assessor1" required>
                    <option v-for="(item, index) in assessors" v-bind:key="item.id" v-bind:value="item.id">{{item.first_name}} {{item.last_name}}</option>
                  </select>  
                </div>
                <div class="col-sm-12">
                  <label>Standards</label>
                  <div class="form-check mb-2" v-for="(item, index) in standards" v-bind:key="item.id" v-bind:value="item.id">
                    <input class="form-check-input" type="checkbox" :dataset="item.id" :id="'flexSwitchCheckDefault'+item.id">
                    <label class="form-check-label" :for="'flexSwitchCheckDefault'+item.id">{{item.code}} - {{item.name}}</label>
                  </div>
                </div>
             </div>
          </div>
          <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addAssessment" v-bind:disabled="addAssessmentProcess  || deleteAssessmentProcess || activateAssessmentProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addAssessmentProcess">
              Ajouter
              </button>
          </div>
        </form>
        </div>
      </div>
    </div>
    <!-- View Modal Assessment -->
    <div class="modal fade" id="viewModalAssessment" tabindex="-1" role="dialog" aria-labelledby="ModalAssessmentLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalAssessmentLabel">Assessment [#<span>{{indexAssessment+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Mission</th>
                  <td>{{mission2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Evaluateur</th>
                  <td>{{assessor2}}</td>
                </tr>
                <tr>
                  <th scope="row">Type</th>
                  <td>{{type2}}</td>
                </tr>
                <tr>
                  <th scope="row">Site</th>
                  <td>{{site2}}</td>
                </tr>
                <tr>
                  <th scope="row">Date début</th>
                  <td>{{start_date2}}</td>
                </tr>
                <tr>
                  <th scope="row">Date fin</th>
                  <td>{{end_date2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Modal Assessment -->
    <div class="modal fade" id="deleteModalAssessment" tabindex="-1" role="dialog" aria-labelledby="ModalAssessmentLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalAssessmentLabel">Supprimer Assessment [#<span>{{indexAssessment+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer cette évaluation ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteAssessment" v-bind:disabled="addAssessmentProcess  || deleteAssessmentProcess || activateAssessmentProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteAssessmentProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      assessment: {},
      indexAssessment: '',
      assessments: [],
      missions: [],
      sites: [],
      assessors: [],
      standards: [],
      clients: [],
      addAssessmentProcess: false,
      viewAssessmentProcess: false,
      deleteAssessmentProcess: false,      
      activateAssessmentProcess: false,      
      isSuccess: true,
      isError: false,
      messageAlert: '',
      name1: '',
      description1: '',
      type1: '',
      client1: '',
      mission1: '',
      site1: '',
      assessor1: '',
      standard1: [],
      date1: '',
      id2: '',
      mission2: '',
      name2: '',
      assessor2: '',
      type2: '',
      site2: '',
      start_date2: '',
      end_date2: '',
      dTableAssessment: ''
    }
  },
  methods: {
    init () {
      setTimeout(() => {
        this.dTableAssessment = $('#dataTableAssessment').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            { 'width': '180' },
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.assessment = {
            id: '',
            client_id: '',
            mission_id: '',
            site_id: '',
            assessor_id: '',
            name: '',
            description: '',
            type:  '',
            eval_date:  '',
            start_date: '',
            end_date: '',
            is_finished: 0,
            standards: []
        }
        this.name1 = ''
        this.type1 = ''
        this.description1 = ''
        this.client1 = ''
        this.mission1 = ''
        this.site1 = ''
        this.assessor1 = ''
        this.standard1 = ''
        this.date1 = ''
      }, 50)
    },
    getAssessments () {
      axios.get(this.apiUrl+'/assessments')
        .then(res => {
          this.assessments = res.data
          this.progress += 1
          if (this.progress === 6) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getMissions () {
      axios.get(this.apiUrl+'/missions')
        .then(res => {
          this.missions = res.data
          this.missionsSelect = res.data
          this.progress += 1
          if (this.progress === 6) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getSites () {
      axios.get(this.apiUrl+'/sites?site_type_id=3')
        .then(res => {
          this.sites = res.data
          this.progress += 1
          if (this.progress === 6) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getAssessors () {
      axios.get(this.apiUrl+'/assessors')
        .then(res => {
          this.assessors = res.data
          this.progress += 1
          if (this.progress === 6) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getStandards () {
      axios.get(this.apiUrl+'/standards')
        .then(res => {
          this.standards = res.data
          this.progress += 1
          if (this.progress === 6) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    getClients () {
      axios.get(this.apiUrl+'/clients')
        .then(res => {
          this.clients = res.data
          this.progress += 1
          if (this.progress === 6) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    addAssessment () {
      if ($('#addAssessmentForm').isValid()) {
        this.addAssessmentProcess = true
        var standards = []
        $('input[type=checkbox]').each(function () {
            if(this.checked) standards.push(parseInt($(this).attr('dataset')));
        });
        let assessment = {
          id: this.assessments.length + 1,
          client_id: this.client1,
          mission_id: this.mission1,
          site_id: this.site1,
          assessor_id: this.assessor1,
          name: this.name1,
          description: this.description1,
          type: this.type1,
          eval_date: this.date1,
          start_date: "",
          end_date: "",
          is_finished: 0,
          standards: standards
        }
        axios.post(this.apiUrl+'/assessments', assessment).then(res => {
          if (res.statusText == 'Created') {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.assessments.push(assessment)
            this.dTableAssessment.destroy()
            this.init()
          }
          $('#addModalAssessment').modal('hide')
          this.addAssessmentProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalAssessment').modal('hide')
          this.addAssessmentProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    viewAssessment (id) {
      this.assessment = this.assessments.filter(function (item) {
        return item.id === id
      })[0]
      this.indexAssessment = this.assessments.indexOf(this.assessment)
      this.id2 = this.assessment.id
      this.mission2 = this.assessment.mission_id
      this.name2 = this.assessment.name
      this.assessor2 = this.assessment.assessor_id
      this.type2 = this.assessment.type
      this.site2 = this.assessment.site_id
      this.start_date2 = this.assessment.start_date
      this.end_date2 = this.assessment.end_date
    },
    deleteAssessment () {
      let id = this.assessment.id
      this.deleteAssessmentProcess = true
      axios.delete(this.apiUrl+'/assessments/' + id)
        .then(res => {
          if (res.statusText == 'OK') {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.assessments.splice(this.indexAssessment, 1)
            this.dTableAssessment.destroy()
            this.init()
          }
          $('#deleteModalAssessment').modal('hide')
          this.deleteAssessmentProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalAssessment').modal('hide')
          this.deleteAssessmentProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getClients()
    this.getMissions()
    this.getSites()
    this.getStandards()
    this.getAssessors()
    this.getAssessments()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Assessment.vue